(function () {
	document.querySelector("#btn-main-menu").addEventListener("click", (event) => {
		if (event.currentTarget.classList.contains("active")) {
			event.currentTarget.querySelector(".text").innerText = "Close";
		} else {
			event.currentTarget.querySelector(".text").innerText = "Menu";
		}
	});

	// Add escape key listener
	document.addEventListener("keydown", (event) => {
		// Ignore IME composition
		if (event.isComposing || event.keyCode === 229) {
			return;
		}

		// Close menu with ESC key
		if (event.key === "Escape") {
			if (!document.querySelector("#btn-main-menu").classList.contains("active")) {
				document.querySelector("#btn-main-menu").querySelector(".text").innerText = "Menu";
			}
		}
	});

	document
		.querySelector("#menu-featured-header-menu")
		.querySelectorAll(".menu-item-has-children")
		.forEach((li) => {
			li.querySelectorAll(".sub-menu").forEach((subMenu) => {
				subMenu.setAttribute("aria-expanded", "false");
				subMenu.querySelectorAll("*").forEach((link) => {
					if (link.matches("button, a")) {
						link.setAttribute("tabindex", "-1");
					}
				});
			});

			li.addEventListener("click", (e) => {
				e.target.classList.toggle("active");
				const isActive = e.target.classList.contains("active");

				e.target.parentElement.querySelectorAll(".sub-menu").forEach((subMenu) => {
					if (isActive) {
						subMenu.setAttribute("aria-expanded", "true");
						subMenu.querySelectorAll("*").forEach((link) => {
							if (link.matches("button, a")) {
								link.setAttribute("tabindex", "0");
							}
						});
					} else {
						subMenu.setAttribute("aria-expanded", "false");
						subMenu.querySelectorAll("*").forEach((link) => {
							if (link.matches("button, a")) {
								link.setAttribute("tabindex", "-1");
							}
						});
					}
				});
			});
		});

	document
		.querySelector("#menu-main-menu")
		.querySelectorAll(".menu-item-has-children button.btn__heading")
		.forEach((button) => {
			const target = button.nextElementSibling;
			button.addEventListener("click", (event) => {
				if (button.classList.contains("active")) {
					target.classList.remove("active");
					target.style.maxHeight = null;
					button.classList.remove("active");
				} else {
					target.classList.add("active");
					target.style.maxHeight = target.scrollHeight + "px";
					button.classList.add("active");
				}
			});
		});
})();
